// extracted by mini-css-extract-plugin
export default {"root":"LastReleaseCard_root__ZxfjG","badge":"LastReleaseCard_badge__GZK4-"};